import * as _ from 'underscore';
import { taOptions } from 'textangular';
import { WysiwygServiceComponent, WysiwygService } from '../services/wysiwyg.service';

export abstract class WysiwygControllerBase {
    instanceWysiwygService: WysiwygServiceComponent = null;
    constructor(
        protected $scope: ng.IScope,
        protected taOptions: taOptions,
        protected wysiwygService: WysiwygService,
    ) {
        this.instanceWysiwygService = wysiwygService.instance();
        let taToolbarItems = [this.instanceWysiwygService.taToolbar.insertImage, this.instanceWysiwygService.taToolbar.insertLink];
        let taToolbar = taOptions.toolbar[2] as string[];
        let removeItems = [];
        _.forEach(taToolbarItems, (item) => {
            if (!_.contains(taToolbar, item)
            ) {
                removeItems.push(item);
                taToolbar.splice(taToolbar.length - 1, 0, item);
            }
        });

        taOptions.externalComponent = this.instanceWysiwygService;

        this.$scope.$on('$destroy', () => {

            this.instanceWysiwygService.removeExcessTokens();
            _.forEach(removeItems, (item) => {
                taToolbar.splice(taToolbar.indexOf(item), 1);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/controllers/wysiwygControllerBase.ts